import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class LangTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Sprachauswahl" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Language: Deutsch', descriptionColumn: 'Darstellung der Benutzeroberfläche in deutscher Sprache' },
        { actionColumn: 'Language: English', descriptionColumn: 'Darstellung der Benutzeroberfläche in Englisch' },
        { actionColumn: 'Language: Français', descriptionColumn: 'Darstellung der Benutzeroberfläche in Französisch' },
        { actionColumn: 'Language: Polski', descriptionColumn: 'Darstellung der Benutzeroberfläche in Polnisch' },
        { actionColumn: 'Language: Español', descriptionColumn: 'Darstellung der Benutzeroberfläche in Spanisch' },
        { actionColumn: 'Language: Italiano', descriptionColumn: 'Darstellung der Benutzeroberfläche in Italienisch' },
        { actionColumn: 'Language: Nederlands', descriptionColumn: 'Darstellung der Benutzeroberfläche in Holländisch' },
        { actionColumn: 'Language: Português', descriptionColumn: 'Darstellung der Benutzeroberfläche in Portugiesisch' },
        { actionColumn: 'Language: Svenska', descriptionColumn: 'Darstellung der Benutzeroberfläche in Swedisch' },
        { actionColumn: 'Language: Türk', descriptionColumn: 'Darstellung der Benutzeroberfläche in Türkisch' },
        { actionColumn: 'Language: 日本語', descriptionColumn: 'Darstellung der Benutzeroberfläche in Japanisch' },
        { actionColumn: 'Language: 中文(简体)', descriptionColumn: 'Darstellung der Benutzeroberfläche in Chinesisch' },
        { actionColumn: 'Language: بالعربية', descriptionColumn: 'Darstellung der Benutzeroberfläche in Arabisch' },
        { actionColumn: 'Language: Русский', descriptionColumn: 'Darstellung der Benutzeroberfläche in Russisch' }
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

LangTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(LangTable)